"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dashboard = require("@/api/dashboard.js");
var _index = _interopRequireDefault(require("@/components/echartsNew/index"));
var _index2 = _interopRequireDefault(require("@/components/ButtonTimePicker/index"));
var _index3 = _interopRequireDefault(require("@/components/StatisticsDataCardList/index"));
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  name: 'orderStatistic',
  components: {
    echartsNew: _index.default,
    ButtonTimePicker: _index2.default,
    StatisticsDataCardList: _index3.default
  },
  mixins: [],
  props: {},
  data: function data() {
    return {
      startTime: '',
      // 开始时间
      endTime: '',
      // 结束时间
      orderStatisticsData: [],
      // 订单统计数据
      orderLineLoading: true,
      // 订单折线图是否加载
      orderTypeLoading: true,
      // 订单类型图是否加载
      orderShippingLoading: true,
      // 发货方式图是否加载
      style: {
        height: '320px'
      },
      // 订单线形图选项
      orderLineOption: {
        // 图像位置
        grid: {
          top: 50,
          left: 0,
          right: 50,
          bottom: 40,
          containLabel: true
        },
        color: ['#5B8FF9', '#5AD8A6', '#F6BD16', '#A78BFA'],
        // 指针数据显示
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          }
        },
        // 图例
        legend: {
          top: 10,
          left: 'center',
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          data: ['订单金额', '退款金额', '订单数量', '退款数量']
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          axisLine: {
            lineStyle: {
              color: '#E5E8EF'
            }
          },
          axisLabel: {
            color: '#666'
          },
          data: []
        },
        yAxis: [{
          type: 'value',
          name: '金额',
          position: 'left',
          min: 0,
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#F0F0F0'
            }
          },
          axisLabel: {
            color: '#666',
            margin: 30
          }
        }, {
          type: 'value',
          name: '数量',
          position: 'right',
          min: 0,
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#F0F0F0'
            }
          },
          axisLabel: {
            color: '#666',
            margin: 30
          }
        }],
        series: [{
          name: '订单金额',
          type: 'bar',
          yAxisIndex: 0,
          smooth: true,
          symbol: 'none',
          symbolSize: '8',
          lineStyle: {
            width: 2
          },
          barMaxWidth: 20,
          data: []
        }, {
          name: '退款金额',
          type: 'bar',
          yAxisIndex: 0,
          smooth: true,
          symbol: 'none',
          symbolSize: '8',
          lineStyle: {
            width: 2
          },
          barMaxWidth: 20,
          data: []
        }, {
          name: '订单数量',
          type: 'line',
          yAxisIndex: 1,
          smooth: true,
          symbol: 'none',
          symbolSize: '8',
          lineStyle: {
            width: 2
          },
          data: []
        }, {
          name: '退款数量',
          type: 'line',
          yAxisIndex: 1,
          smooth: true,
          symbol: 'none',
          symbolSize: '8',
          lineStyle: {
            width: 2
          },
          data: []
        }]
      },
      // 订单类型饼图选项
      orderTypeOption: {
        title: {
          text: '订单类型',
          left: 0,
          top: 10,
          textStyle: {
            fontSize: 18,
            fontWeight: 600
          }
        },
        color: ['#3B82F6', '#34D399', '#60A5FA', '#F59E0B', '#FB923C', '#EF4444', '#A78BFA', '#F472B6', '#C084FC'],
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: 0,
          top: 50,
          icon: 'circle'
          // itemWidth: 8,
          // itemHeight: 8,
        },
        series: [{
          name: '订单类型',
          type: 'pie',
          // radius: '65%',
          radius: ['40%', '70%'],
          center: ['60%', '55%'],
          avoidLabelOverlap: true,
          // 是否开启标签重叠处理
          label: {
            show: true,
            position: 'outside',
            formatter: '{b}'
          },
          labelLine: {
            show: true,
            length: 14,
            length2: 10,
            smooth: true
          },
          data: []
        }]
      },
      // 发货方式饼图选项
      orderShippingOption: {
        title: {
          text: '发货方式',
          left: 0,
          top: 10,
          textStyle: {
            fontSize: 18,
            fontWeight: 600
          }
        },
        color: ['#3B82F6', '#34D399', '#60A5FA', '#F59E0B', '#FB923C', '#EF4444', '#A78BFA', '#F472B6', '#C084FC'],
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: 0,
          top: 50,
          icon: 'circle'
          // itemWidth: 8,
          // itemHeight: 8,
        },
        series: [{
          name: '发货方式',
          type: 'pie',
          // radius: '65%',
          radius: ['40%', '70%'],
          center: ['60%', '55%'],
          avoidLabelOverlap: true,
          // 是否开启标签重叠处理
          label: {
            show: true,
            position: 'outside',
            formatter: '{b}'
          },
          labelLine: {
            show: true,
            length: 14,
            length2: 10,
            smooth: true
          },
          data: []
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    // 获取订单类型饼图数据
    this.getOrderTypePieData();
    // 获取发货方式饼图数据
    this.getProductShippingPieData();
  },
  destoryed: function destoryed() {},
  methods: {
    checkPermi: _permission.checkPermi,
    // 获取订单统计数据
    getOrderStatisticsData: function getOrderStatisticsData() {
      var _this = this;
      var param = {
        startTime: this.startTime,
        endTime: this.endTime
      };
      (0, _dashboard.getOrderStatisticsDataApi)(param).then(function (res) {
        _this.orderStatisticsData = res;
      }).catch(function (err) {
        _this.Message.error(err.msg);
      });
    },
    // 获取订单折线图数据
    getOrderLineData: function getOrderLineData() {
      var _this2 = this;
      var param = {
        startTime: this.startTime,
        endTime: this.endTime
      };
      (0, _dashboard.getOrderLineDataApi)(param).then(function (res) {
        var xAxis = [],
          orderPrice = [],
          refundPrice = [],
          orderVolume = [],
          refundVolume = [];
        res.forEach(function (item, index) {
          xAxis.push(item.date);
          orderPrice.push(item.orderPrice);
          refundPrice.push(item.refundPrice);
          orderVolume.push(item.orderVolume);
          refundVolume.push(item.refundVolume);
        });
        _this2.orderLineOption.xAxis.data = xAxis;
        _this2.orderLineOption.series[0].data = orderPrice;
        _this2.orderLineOption.series[1].data = refundPrice;
        _this2.orderLineOption.series[2].data = orderVolume;
        _this2.orderLineOption.series[3].data = refundVolume;
        _this2.orderLineLoading = false;
      }).catch(function (err) {
        _this2.Message.error(err.msg);
      });
    },
    // 获取订单分类饼图数据
    getOrderTypePieData: function getOrderTypePieData() {
      var _this3 = this;
      var param = {
        startTime: this.startTime,
        endTime: this.endTime
      };
      (0, _dashboard.getOrderTypePieDataApi)(param).then(function (res) {
        _this3.orderTypeOption.series[0].data = res;
        _this3.orderTypeLoading = false;
      }).catch(function (err) {
        _this3.Message.error(err.msg);
      });
    },
    // 获取订单类型饼图数据
    getProductShippingPieData: function getProductShippingPieData() {
      var _this4 = this;
      var param = {
        startTime: this.startTime,
        endTime: this.endTime
      };
      (0, _dashboard.getProductShippingPieDataApi)(param).then(function (res) {
        _this4.orderShippingOption.series[0].data = res;
        _this4.orderShippingLoading = false;
      }).catch(function (err) {
        _this4.Message.error(err.msg);
      });
    },
    // 日期范围更改
    dateRangeChange: function dateRangeChange(timeVal) {
      this.orderLineLoading = true;
      this.startTime = timeVal[0];
      this.endTime = timeVal[1];
      if (timeVal && timeVal[0] == timeVal[1]) {
        this.orderLineOption.series.forEach(function (item, index) {
          item.symbol = 'circle';
        });
      } else {
        this.orderLineOption.series.forEach(function (item, index) {
          item.symbol = 'none';
        });
      }
      // 获取订单统计数据
      this.getOrderStatisticsData();
      // 获取订单折线图数据
      this.getOrderLineData();
    }
  }
};